import React, { useState } from "react";
import { connect } from "react-redux";
import {
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE
} from "../../constants/ThemeSetting";
import ClaireChatPopup from "./ClaireChatPopup";

const Claire = ({ navStyle, width }) => {
  // Determine if sidebar is collapsed/mini
  const isCollapsed = navStyle === NAV_STYLE_MINI_SIDEBAR || 
                     navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
                     width < TAB_SIZE;

  // Chat popup state
  const [isChatOpen, setIsChatOpen] = useState(false);

  const handleClaireClick = () => {
    setIsChatOpen(true);
  };

  const handleChatClose = () => {
    setIsChatOpen(false);
  };

  return (
    <>
      <div 
        className="gx-claire-container" 
        style={{
          height: "64px",
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          cursor: "pointer"
        }}
        onClick={handleClaireClick}
      >
      <div 
        className="gx-claire-avatar"
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          overflow: "hidden",
          flexShrink: 0,
          border: "2px solid rgba(255, 255, 255, 0.2)"
        }}
      >
        <img 
          src="/Claire.png" 
          alt="Claire AI Assistant"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover"
          }}
        />
      </div>
      {!isCollapsed && (
        <div 
          className="gx-claire-text"
          style={{
            marginLeft: "12px"
          }}
        >
          <span 
            style={{
              color: "#fff",
              fontSize: "14px",
              fontWeight: "500",
              whiteSpace: "nowrap"
            }}
          >
            Ask Claire
          </span>
        </div>
      )}
      </div>
      
      {/* Chat Popup */}
      {isChatOpen && (
        <ClaireChatPopup
          isOpen={isChatOpen}
          onClose={handleChatClose}
          sidebarCollapsed={isCollapsed}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ settings }) => {
  const { navStyle, width } = settings;
  return { navStyle, width };
};

export default connect(mapStateToProps)(Claire); 